document.addEventListener("DOMContentLoaded", function () {
    const swatches = document.querySelectorAll(".travel-essentials .form-control");
    swatches.forEach(function (swatch) {
        swatch.addEventListener("change", function (evt) {
            const selectedValue = evt.target.value;
            const closestBtn = evt.target.closest(".product-bundle-card__option").querySelector(".cta-travel");
            if (closestBtn) {
                const buttonUrl = new URL(closestBtn.href, window.location.origin);
                buttonUrl.searchParams.set('variant', selectedValue);
                closestBtn.href = buttonUrl.pathname + buttonUrl.search;
            }
        });
    });
});
